// Configuration file for API endpoints and other global settings

// Get API URL from environment variable with fallback
const baseUrl = process.env.REACT_APP_API_BASE_URL || 'https://iinsaf.shop';

// Log the base URL for debugging (only in development)
if (process.env.NODE_ENV === 'development') {
  console.log('🌐 API Base URL:', baseUrl);
}

// Export configuration variables
export { baseUrl };
